import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import { Link } from "react-router-dom";
export default function VideoCard(props) {
  const { imgLink, title, releaseDate, _id, getParam } = props;
  const calculateDays = (date1) => {
    const d1 = new Date(date1);
    const d2 = new Date();
    const diffDates = parseInt((d2 - d1) / (1000 * 60 * 60 * 24 * 30 * 12), 10);
    if (diffDates > 0) {
      return diffDates + " years ago";
    } else {
      return (
        parseInt((d2 - d1) / (1000 * 60 * 60 * 24 * 30 * 12), 10) +
        " months ago"
      );
    }
  };
  const handleClick = () => {
    getParam(_id);
  };
  return (
    <Link style={{ textDecoration: "none" }} to={`/${_id}`}>
      <Card sx={{ maxWidth: 345 }} onClick={handleClick}>
        <CardActionArea>
          <CardMedia component="img" height="140" image={imgLink} alt={title} />
          <CardContent style={{ backgroundColor: "black" }}>
            <Typography
              className="video-title"
              gutterBottom
              variant="h6"
              component="div"
              style={{
                color: "white",
                backgroundColor: "none",
                border: "none",
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              style={{ color: "white", backgroundColor: "none" }}
            >
              {calculateDays(releaseDate)}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Link>
  );
}
